var React = require('react');

function Polygon3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 7L3.01142e-07 13.9282L9.06825e-07 0.0717964L12 7Z","fill":"#FCB34E"}));
}

Polygon3.defaultProps = {"width":"12","height":"14","viewBox":"0 0 12 14","fill":"none"};

module.exports = Polygon3;

Polygon3.default = Polygon3;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/images/Polygon_3.svg
// module id = 332
// module chunks = 0